import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import IconClose from '../Icons/Close';
import IconEdit from '../Icons/Edit';
import * as style from './style';

class EditableTitle extends PureComponent {
  state = {
    edit: false,
  };

  openEdit = () => this.setState({ edit: true });

  closeEdit = () => this.setState({ edit: false });

  setWrapperRef = (ref, node) => {
    this[ref] = node;
  };

  handleClickOutside = event => {
    if (
      !(this.inpTitle === event.target || this.btnEdit.contains(event.target)) &&
      this.state.edit
    ) {
      this.closeEdit();
    }
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  render() {
    const {
      placeholder,
      title,
      onChange,
      error,
      id,
      iconCloseColor,
      iconCloseSize,
      iconEditColor,
      iconEditSize,
      fontSize,
      fontWeight,
      fontColor,
      width,
      height,
      noMargin,
      maxLength,
    } = this.props;
    const { edit } = this.state;

    return (
      <style.Header>
        <style.Row>
          <style.Content noMargin={noMargin}>
            <style.CustomInput
              id={id || 'inp-editable-title'}
              name={id || 'inp-editable-title'}
              debounceTimeout={350}
              fontSize={fontSize}
              placeholder={edit ? '' : placeholder}
              error={error || undefined}
              value={title}
              fontWeight={fontWeight}
              fontcolor={fontColor}
              width={width}
              height={height}
              onChange={onChange}
              onFocus={this.openEdit}
              active={this.state.edit ? 1 : 0}
              ref={node => this.setWrapperRef('inpTitle', node)}
              maxLength={maxLength ? maxLength : 99}
            />
            <style.Button
              className={!edit ? 'btn-edit-title' : 'btn-close-edit-title'}
              onClick={!edit ? this.openEdit : this.closeEdit}
              ref={node => this.setWrapperRef('btnEdit', node)}
            >
              {edit ? (
                <IconClose color={iconCloseColor} size={iconCloseSize} />
              ) : (
                <IconEdit color={iconEditColor} size={iconEditSize} />
              )}
            </style.Button>
          </style.Content>
        </style.Row>
      </style.Header>
    );
  }
}

EditableTitle.propTypes = {
  active: PropTypes.bool,
  title: PropTypes.string,
  iconCloseColor: PropTypes.string,
  iconCloseSize: PropTypes.string,
  iconEditColor: PropTypes.string,
  iconEditSize: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  fontWeight: PropTypes.string,
  fontColor: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  noMargin: PropTypes.bool,
  maxLength: PropTypes.number,
};

EditableTitle.defaultProps = {
  placeholder: 'Nome do Vale Promocional',
  error: false,
  maxLength: 99,
};

export default EditableTitle;



// WEBPACK FOOTER //
// ./src/components/EditableTitle/index.js